import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer
      style={{
        marginTop: "40px",
        borderTop: "1px solid #d1fae5",
        paddingTop: "30px",
        marginLeft: "-30px",
        marginRight: "-30px",
      }}
    >
      <div
        style={{
          background: "linear-gradient(145deg, #ffffff 0%, #f8fafc 55%, #f0fdf4 100%)",
          borderRadius: "0",
          border: "1px solid #dcfce7",
          boxShadow: "0 12px 30px rgba(15,23,42,0.06)",
          padding: "32px 58px",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))",
            gap: "24px",
          }}
        >
          <div>
            <h3
              style={{
                margin: "0 0 10px 0",
                color: "#0f172a",
                fontSize: "28px",
                fontFamily: '"Playfair Display", Georgia, "Times New Roman", serif',
              }}
            >
              Manna
            </h3>
            <p
              style={{
                margin: 0,
                color: "#475569",
                lineHeight: "1.7",
                fontSize: "14px",
              }}
            >
              Natural aloe vera based skincare and personal care products for everyday beauty.
            </p>
          </div>

          <div>
            <h4 style={headingStyle}>Quick Links</h4>
            <div style={linkColumnStyle}>
              <Link to="/" style={internalLinkStyle}>Home</Link>
              <Link to="/order-status" style={internalLinkStyle}>Track Order</Link>
              <a href="https://example.com" style={externalLinkStyle}>Coming Soon</a>
            </div>
          </div>

          <div>
            <h4 style={headingStyle}>Contact Details</h4>
            <div style={textColumnStyle}>
              <p style={textLineStyle}>Phone: +91 8919755581</p>
              <p style={textLineStyle}>Email: navajeevan@redaloeveraindustries.in</p>
              <p style={textLineStyle}>Address: Kadapa, Andhra Pradesh, India</p>
            </div>
          </div>

          <div>
            <h4 style={headingStyle}>Connect</h4>
            <div style={linkColumnStyle}>
              <a href="https://instagram.com" style={externalLinkStyle}>Instagram</a>
              <a href="https://facebook.com" style={externalLinkStyle}>Facebook</a>
              <a href="https://youtube.com" style={externalLinkStyle}>YouTube</a>
            </div>
          </div>
        </div>

        <div
          style={{
            marginTop: "26px",
            paddingTop: "14px",
            borderTop: "1px solid #e2e8f0",
            color: "#64748b",
            fontSize: "13px",
            textAlign: "center",
          }}
        >
          ® 2026 Manna. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

const headingStyle = {
  margin: "0 0 12px 0",
  color: "#0f172a",
  fontSize: "16px",
};

const linkColumnStyle = {
  display: "grid",
  gap: "9px",
};

const textColumnStyle = {
  display: "grid",
  gap: "9px",
};

const textLineStyle = {
  margin: 0,
  color: "#475569",
  fontSize: "14px",
  lineHeight: "1.6",
};

const internalLinkStyle = {
  textDecoration: "none",
  color: "#166534",
  fontWeight: "600",
  fontSize: "14px",
};

const externalLinkStyle = {
  textDecoration: "none",
  color: "#334155",
  fontWeight: "600",
  fontSize: "14px",
};

export default Footer;
